import { createAction, props } from '@ngrx/store';
import { IPermissionsState, UserPermission } from './permissions.state';

export enum PermissionsActions {
  PermissionsRequested = '[Permissions] Permissions Requested',
  PermissionsLoaded = '[Permissions] Permissions Loaded',
  PermissionsError = '[Permissions] Permissions Error',
  UserPermissionsRequested = '[UserPermissions] User Permissions Requested',
  UserPermissionsLoaded = '[UserPermissions] User Permissions Loaded',
  UserPermissionsError = '[UserPermissions] User Permissions Error',
  LoggedUserPermissionsRequested = '[LoggedUserPermissions] Logged User Permissions Requested',
  LoggedUserPermissionsLoaded = '[LoggedUserPermissions] Logged User Permissions Loaded',
  LoggedUserPermissionsError = '[LoggedUserPermissions] Logged User Permissions Error'
}

export const PermissionsRequested = createAction(PermissionsActions.PermissionsRequested);

export const PermissionsLoaded =  createAction(
  PermissionsActions.PermissionsLoaded,
  props<{ permissions: IPermissionsState['permissions'] }>()
);

export const PermissionsError = createAction(PermissionsActions.PermissionsError);

export const UserPermissionsRequested = createAction(PermissionsActions.UserPermissionsRequested);

export const UserPermissionsLoaded = createAction(
  PermissionsActions.UserPermissionsLoaded,
  props<{ userPermissions: IPermissionsState['userPermissions'] }>()
);

export const UserPermissionsError = createAction(PermissionsActions.UserPermissionsError);

export const LoggedUserPermissionsRequested = createAction(PermissionsActions.LoggedUserPermissionsRequested);

export const LoggedUserPermissionsLoaded = createAction(
  PermissionsActions.LoggedUserPermissionsLoaded,
  props<{ loggedUserPermissions: IPermissionsState['loggedUserPermissions'] }>()
);

export const LoggedUserPermissionsError = createAction(PermissionsActions.LoggedUserPermissionsError);